import React from 'react';

const InSpaceTheme = {
  headerLogo: {
    src: '/themes/theme/inspace/inspace-logo.png',
    alt: 'Incast Logo',
    size: 60,
  },
  darkLogo: {
    src: '/themes/theme/inspace/inspace-logo.png',
    alt: 'InSpace Logo',
    size: 150,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #FEC909',
    height: 60,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'InSpace',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="120"
        src="/themes/theme/inspace/inspace-logo.png" alt="Inspace Logo"
      />
      <br /><br />
      <h3>InSpace</h3>
    </div>
  ),
  shareSite: 'https://share-influencer.inspace.asia',
};

export default InSpaceTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/inspace.js
 **/